import { render } from "./PublicSectionHeader.vue?vue&type=template&id=cb0e5538"
import script from "./PublicSectionHeader.vue?vue&type=script&lang=js"
export * from "./PublicSectionHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__